import React from "react";
import { ADD_NEW, NO_RECORD, NULL_VALUE, SEPERATOR, includes } from "../Constants";
export function useDataSource(props) {
    const { dataSource, filter, filter2, visible, textField, searchText, searchFn, doAddNew, valueField, disabled, readOnly } = props;
    const dataSourceIncludesValue = (value) => {
        if (dataSource.length === 0)
            return false;
        if (dataSource[0] instanceof Array) {
            for (const dsSlice of dataSource) {
                if (dsSlice.some(x => x[valueField] === value))
                    return true;
            }
            return false;
        }
        else {
            return dataSource.some(x => x[valueField] === value);
        }
    };
    const filteredDataSource = React.useMemo(() => {
        return filterDataSource({ dataSource, open: visible, filter, filter2 });
    }, [filter, filter2, dataSource, visible]);
    const searchedDataSource = React.useMemo(() => {
        return searchDataSource({ dataSource: filteredDataSource, textField, searchText, searchFn });
    }, [filteredDataSource, searchFn, searchText, textField]);
    const flatDataSource = React.useMemo(() => {
        return flattenDataSource({ dataSource: searchedDataSource, addNew: doAddNew });
    }, [doAddNew, searchedDataSource]);
    // const selectedText = React.useMemo(() => {
    // 	const item = findText({ dataSource, valueField, value });
    // 	if (!item) return undefined;
    // 	const text = typeof textField === "function" ? textField(item) : item[textField];
    // 	return text;
    // }, [dataSource, textField, value, valueField]);
    // const selectedIndex = React.useMemo(() => {
    // 	return flatDataSource.findIndex(item => item === SEPERATOR || item === NO_RECORD || item === ADD_NEW ? false : item[valueField] === value);
    // }, [flatDataSource, value, valueField])
    const getValueByIndex = React.useCallback((index) => {
        if (index < 0)
            return NULL_VALUE;
        if (disabled || readOnly)
            return NULL_VALUE;
        const item = flatDataSource[index];
        if (item === SEPERATOR || item === NO_RECORD || item === ADD_NEW)
            return NULL_VALUE;
        return item[valueField];
    }, [disabled, flatDataSource, readOnly, valueField]);
    return { flatDataSource, getValueByIndex, dataSourceIncludesValue };
}
function getText(item, textField) {
    return typeof textField === "function" ? textField(item) : item[textField];
}
export function findText({ dataSource, valueField, value }) {
    const isAoA = dataSource[0] instanceof Array;
    if (isAoA) {
        for (let i = 0; i < dataSource.length; i++) {
            const item = dataSource[i].find(item => item[valueField] === value);
            if (item)
                return item;
        }
        return undefined;
    }
    else {
        //@ts-nocheck
        return dataSource.find(item => item[valueField] === value);
    }
}
export function flattenDataSource({ dataSource, addNew }) {
    const isAoA = dataSource[0] instanceof Array;
    let flatDataSource = [];
    if (isAoA) {
        for (let i = 0; i < dataSource.length; i++) {
            if (dataSource[i].length === 0)
                continue;
            flatDataSource.push(...dataSource[i]);
            if (i < dataSource.length - 1)
                flatDataSource.push(SEPERATOR);
        }
        // return flatDataSource;
    }
    else {
        flatDataSource = dataSource;
        // if (addNew) return [ADD_NEW, ...dataSource];
        // else return dataSource;
    }
    if (flatDataSource.length === 0)
        flatDataSource.push(NO_RECORD);
    if (addNew) {
        flatDataSource.unshift(SEPERATOR);
        flatDataSource.unshift(ADD_NEW);
    }
    return flatDataSource;
}
export function searchDataSource({ dataSource, textField, searchText, searchFn }) {
    if (dataSource.length === 0)
        return dataSource;
    if (!searchText)
        return dataSource;
    const searchFilter = searchFn ?? ((item, search) => {
        const text = getText(item, textField);
        return includes(text, search);
    });
    if (dataSource[0] instanceof Array) {
        const filteredDataSource = [];
        for (let i = 0; i < dataSource.length; i++) {
            const dataSourceItem = dataSource[i].filter(item => searchFilter(item, searchText));
            if (dataSourceItem.length > 0) {
                filteredDataSource.push(dataSourceItem);
            }
        }
        return filteredDataSource;
    }
    else {
        return dataSource.filter(item => searchFilter(item, searchText));
    }
}
export function filterDataSource(props) {
    const allFilter = (item) => {
        if (filter && filter2)
            filter(item) && filter2(item);
        else if (filter)
            filter(item);
        else if (filter2)
            filter2(item);
        return true;
    };
    const { dataSource, filter2, filter } = props;
    //TODO: Commenting this line temporarily. By doing this the scroll does not scroll to
    //selected item when opened. Need to debug and figure out.
    // if (!props.open) return [];
    if (dataSource.length === 0)
        return dataSource;
    if (dataSource[0] instanceof Array) {
        const filteredDataSource = [];
        for (let i = 0; i < dataSource.length; i++) {
            const dataSourceItem = dataSource[i].filter(item => allFilter(item));
            if (dataSourceItem.length > 0) {
                filteredDataSource.push(dataSourceItem);
            }
        }
        return filteredDataSource;
    }
    else {
        return dataSource.filter(item => allFilter(item));
    }
}
